
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  @Prop({ type: Boolean, default: true }) public left;
  public imgSrc = "homeIcons/retreat.png"

  public mounted() {
    if (!this.left) this.imgSrc = "img/login/close.png";
  }

  public onClickLeft() {
    if (!this.left) return this.$emit("onClose", false);
    this.$router.go(-1);
  }

  public getImgUrl() {
    return require(`@/assets/${this.imgSrc}`);
  }
}
